import React, { useState } from 'react';
import './../../../assets/scss/style.scss';
const Login = () => {
    let [user, setUser] = useState({
        email: '',
        password: ''
    });
    let [userError, setUserError] = useState({
        emailError: '',
        passwordError: ''
    });
    return (
        <div className="c-backgroundColor c-container">
            <div className="form-box">
                <div className="header-form">
                    <h4 className="text-primary text-center">
                        <i className="fa fa-user-circle" style={{ fontSize: '110px' }}></i>
                    </h4>
                    <div className="image"></div>
                </div>
                <div className="body-form">
                    <form>
                        <div className="input-group mb-3 c-input-group">
                            <div className="input-group-prepend mx-2">
                                <span className="c-input-group-text bg-white">
                                    <i className="fa fa-user c-color"></i>
                                </span>
                            </div>
                            <input type="text" className=" c-input" placeholder="Username" />
                        </div>
                        <div className="input-group mb-3 c-input-group">
                            <div className="input-group-prepend mx-2">
                                <span className="c-input-group-text bg-white">
                                    <i className="fa fa-lock c-color"></i>
                                </span>
                            </div>
                            <input type="password" className="c-input" placeholder="Password" />
                            <div className="input-group-append mx-2">
                                <span className="c-input-group-text-password bg-white">
                                    <i className="fa fa-eye c-color"></i>
                                </span>
                            </div>
                        </div>
                        <div className="message">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Remember me
                                </label>
                            </div>
                            <div>
                                <a href="#">Forgot password?</a>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            <button type="button" className="btn btn-primary c-button">
                                LOGIN
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
